import {
  NOTIFICATION_UPDATE,
  NOTIFICATION_CLEAR_CHANNEL,
} from '../actionTypes/notifications';
import { MaybeNil } from '../../utils/interfaces';

export const notificationUpdateAction = (notificationData: {
  wsNotifications: any[];
}) => ({
  type: NOTIFICATION_UPDATE,
  payload: notificationData,
});

export const clearChannelNotificationsAction = ({
  workspaceId,
  channelId,
}: {
  workspaceId: MaybeNil<string>;
  channelId: MaybeNil<string>;
}) => ({
  type: NOTIFICATION_CLEAR_CHANNEL,
  payload: { workspaceId, channelId },
});
